export default __webpack_public_path__ + "static/media/isl.e25c8dba.png";